import { i18nKeys, useTranslate } from '@gloat/glocalize';
import { LocationLabelType, LocationLimitationTypes, Location } from '@gloat/types';

type LocationLabelRetval = { locationLimitation?: LocationLabelType; locations?: LocationLabelType[] };

type UseLocationLabelsRetVal = {
  getLocationLabels: () => LocationLabelRetval;
  getLocationLabelText: () => string;
};

const useLocationLabels = ({
  locationLimitation,
  locations,
  location,
}: {
  locationLimitation?: LocationLimitationTypes;
  locations?: Location[];
  location?: Location;
}): UseLocationLabelsRetVal => {
  const translate = useTranslate();
  const locationsAsArray = locations && locations.length > 0 ? locations : location ? [location] : [];

  // Return the relevant location labels for each opportunity: locations (for ex: Tel Aviv) and location limitation (for ex: global)
  const getLocationLabels = (): LocationLabelRetval => {
    const retVal: LocationLabelRetval = {};

    // Local opportunities displays just the locations but not the location limitation (Which is LOCAL)
    if (locationLimitation && locationLimitation !== 'LOCAL') {
      const value = translate({ id: `LOCATION_LIMITATION_LABEL_${locationLimitation}` });

      retVal.locationLimitation = {
        icon: 'MAP',
        text: value,
        value,
        tooltipText: i18nKeys.LOCATION,
      };
    }

    if (locationsAsArray && locationsAsArray.length > 0) {
      retVal.locations = locationsAsArray.map((location: { name: string }) => ({
        icon: 'MAP_MARKER',
        text: location.name,
        value: location.name,
        tooltipText: i18nKeys.LOCATION,
      }));
    }

    return retVal;
  };

  // Convert location labels to a title that includes the relevant data (For ex: 'Remote' or 'Tel-Aviv, Jerusalem')
  const getLocationLabelText = () => {
    const { locationLimitation, locations } = getLocationLabels();
    if (locations && locations.length > 0) {
      return locations.map?.(location => location.text)?.join?.(', ');
    }
    return locationLimitation?.text || '';
  };

  return {
    getLocationLabels,
    getLocationLabelText,
  };
};

export default useLocationLabels;
